import './style.css';
import ReactDOM from 'react-dom/client';
import React, { useState } from 'react';
import { Canvas } from '@react-three/fiber';
import Experience from './Experience.jsx';
import { KeyboardControls } from '@react-three/drei';
import Interface from './Interface.jsx';
import Loader from './Loader.jsx';
import { Leva } from 'leva';

// Definir el mapeo del teclado
const keyboardMap = [
  { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
  { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
  { name: 'left', keys: ['ArrowLeft', 'KeyA'] },
  { name: 'right', keys: ['ArrowRight', 'KeyD'] },
  { name: 'run', keys: ['Shift'] },
  { name: 'jump', keys: ['Space'] },
];

function App() {
  const [booksCollected, setBooksCollected] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const handleLoaded = () => {
    setLoaded(true);
  };

  return (
    <>
      {!loaded && <Loader onLoaded={handleLoaded} />}
      {loaded && (
        <KeyboardControls map={keyboardMap}>
          <Canvas
            shadows
            camera={{
              fov: 75,
              near: 0.1,
              far: 200,
            }}
          >
            <color attach="background" args={["black"]} />
            <Experience setBooksCollected={setBooksCollected} />
          </Canvas>
          <Interface booksCollected={booksCollected} />
          <Leva hidden />
        </KeyboardControls>
      )}
    </>
  );
}

const root = ReactDOM.createRoot(document.querySelector('#root'));
root.render(<App />);
